<template>
  <div
    v-if="card.useReducedPrice"
    class="given-price">
    <RadioGroup
      class="my-5"
      class-name="mt-2 py-0"
      data-qa="use_standard_reduced_price-radio"
      :header="$t('Tenders.CalculationFormula')"
      :items="useReducedPriceOptios"
      :model.sync="card.useStandardReducedPrice"
      row
      @change="changeToStandart"/>
    <ChangeFormula
      ref="formula_editor"
      :card.sync="card"
      :criteria="criteria"
      data-qa="change-given-price-formula"
      :error.sync="error"
      :formula.sync="card.reducedPriceFormula"
      subheader/>
  </div>
</template>

<script>
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import ChangeFormula from 'components/tenders/critetia/ChangeFormula.vue'

import { mapGetters } from 'vuex'
import { criteriasMixin, modalMixin } from 'mixins'

export default {
  name: 'changeGivenPrice',
  mixins: [ modalMixin, criteriasMixin],
  data() {
    return {
      change: false,
      error: false,
    }
  },
  props: {
    criteria: {
      type: Array,
      default: () => []
    },
    variables: Array,
    card: Object
  },
  computed: {
    ...mapGetters({
      tender: 'getNewTender',
    }),
    useReducedPriceOptios() {
      return [
        { label: this.$t('Tenders.StandardFormula') , value: true},
        { label: this.$t('Tenders.YourFormula') , value: false},
      ]
    },
    new_formula: {
      get() {
        return this.formula
      },
      set(val) {
        this.$emit('update:formula', val)
      }
    },
  },
  methods: {
    changeToStandart(ev) {
      if (ev) {
        this.error = false
        this.$emit('changeToStandart', ev)
      }
      this.saveCardToLocalStorage(this.tender, this.card)
    },
  },
  components: {
    RadioGroup,
    ChangeFormula
  }
}
</script>
<style lang="scss" scoped>
.v-card__title {
  word-break: break-word;
}
.list_name__divider {
  border: 1px solid var(--v-main__green-base) !important;
}
</style>
